import React from 'react';

import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export function SingleImageWithSquiggle({
  _type,
  image,
  maxWidth,
  squiggleLine,
  widthClass
}) {
  const imageData = getImage(image?.asset);
  const previewImage = image?.asset?.url;

  return (
    <div
      className={
        classNames(
          widthClass && widthClass,
          maxWidth && maxWidth
        )
      }
      id={_type}
    >
      <div className='inner rel'>
        {squiggleLine && (
          <div
            className='abs fill f svg-animate'
            dangerouslySetInnerHTML={{ __html: squiggleLine.svg }}
          />
        )}
        {imageData && (
          <div
            className={
              classNames(
                'rel image-container f',
                squiggleLine && 'squigglePadding'
              )
            }
          >
            <GatsbyImage
              alt={image?.alt || ''}
              className='f x'
              image={imageData}
            />
          </div>
        )}
        {!imageData && (
          <div
            className={
              classNames(
                'rel image-container f',
                squiggleLine && 'squigglePadding'
              )
            }
          >
            <img
              alt={image?.alt || ''}
              className='f x'
              src={previewImage}
            />
          </div>
        )}
      </div>
    </div>
  );
};
